import React from 'react';
import Proptypes from 'prop-types';
import GLmol from './b_GLmol_modified';

class SaxsAbInitioPDBViewer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            PDBViewerDivHeight: 300,
            isPDBViewerDivHeightUpdated: false,
            isGLViewerInstanceCreated: false
        }

        this.isWebGLEnabled = this.isWebGLEnabled.bind(this);

        this.isWebGLEnabled = this.isWebGLEnabled();
    }

    render() {
        return (<div>
            <textarea
                id='divToRenderPDB_pdb_src'
                style={{ width: '300px', height: '300px', display: 'none' }}
                value={this.props.data}
            />
            <div id='divToRenderPDB_pdb' style={{ height: this.state.PDBViewerDivHeight, backgroundColor: 'black' }}>
                {this.isWebGLEnabled === false ? <span style={{ color: 'white' }}> WebGL is not enabled </span> : null}
            </div>
        </div>);
    }

    componentDidMount() {
        // resize the div height = width
        this.setState({
            PDBViewerDivHeight: document.getElementById('divToRenderPDB_pdb').offsetWidth,
            isPDBViewerDivHeightUpdated: true
        })
    }

    componentDidUpdate() {
        if (this.isWebGLEnabled === true) {
            if (this.state.isGLViewerInstanceCreated === false) {
                if (this.state.isPDBViewerDivHeightUpdated === true) {
                    // we need to make sure the div height is fixed before initializing GLmol because the canvas ratio is based on width and height of the div at initialization
                    this.GLmol = new GLmol('divToRenderPDB_pdb');
                    this.setState({ isGLViewerInstanceCreated: true });
                }
            }

            if (this.props.data) {
                this.GLmol.loadMolecule()
            }
        }
    }

    isWebGLEnabled(return_context) {
        if (!!window.WebGLRenderingContext) {
            let canvas = document.createElement("canvas");
            let names = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"];
            let context = false;
            for (var i = 0; i < 4; i++) {
                try {
                    context = canvas.getContext(names[i]);
                    if (context && typeof context.getParameter == "function") {
                        // WebGL is enabled                    
                        if (return_context) {
                            // return WebGL object if the function's argument is present
                            return {
                                name: names[i],
                                gl: context
                            };
                        }
                        // else, return just true
                        return true;
                    }
                } catch (e) {
                }
            }
            // WebGL is supported, but disabled
            return false;
        }
        // WebGL not supported28.    
        return false;
    }
}

export default SaxsAbInitioPDBViewer;

SaxsAbInitioPDBViewer.proptypes = {
    /* PDB data */
    data: Proptypes.string
}


// WEBPACK FOOTER //
// ./src/components/saxs/SaxsAbInitioPDBViewer.js